import {
  FETCH_CURRENT_INVENTORY_SUCCESS,
  RESET_INVENTORY_ITEM,
  FETCH_INVENTORY_ITEM_SUCCESS,
  FETCH_INVENTORY_ITEM_ERROR,
  FETCH_INVENTORY_ITEM_CARTONS_SUCCESS,
  FETCH_INVENTORY_ITEM_BY_CARTON_ID,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_ERROR,
  CREATE_PRODUCT_CLEAR,
} from "../constants/ActionTypes";

const INIT_STATE = {
  loader: true,
  noContentFoundMessage: "No data found",
  inventoryItem: {
    item: null,
    cartons: null,
  },
  inventoryData: {
    lines: [],
    pageInfo: {
      page: 1,
      offset: 0,
      total: 0,
      previousPage: null,
      nextPage: null
    },
  },
  createdProduct: null,
  alertMessage: '',
  showMessage: false,
};

const inventoryItemMapper = ({ item=null, consignorName='', cartons=null, warehouseEvents=null }) => {
  const mappedInventoryItem = { ...INIT_STATE.inventoryItem };

  if (item) {
    mappedInventoryItem.item = {
      ...item,
      claimedBy: item?.claimedBy?.value ?? '',
      commerceStatusUpdatedAt: item?.commerceStatusUpdatedAt ?? '',
      consignerId: item?.consignerId?.value ?? '',
      consignerName: consignorName ?? '',
      createdAt: item?.createdAt ?? '',
      decisionAt: item?.decisionAt ?? '',
      decisionBy: item?.decisionBy?.value ?? '',
      firstInspectedAt: item?.firstInspectedAt ?? '',
      id: item?.id?.value ?? '',
      inspectedAt: item?.lastInspectedAt ?? '',
      lastInspectedAt: item?.lastInspectedAt ?? '',
      lastInspectedBy: item?.lastInspectedBy?.value ?? '',
      productId: item?.productId?.value ?? '',
      publishedAt: item?.publishedAt ?? '',
      shortId: item?.shortId?.value ?? '',
      warehouseId: item?.warehouseId?.value ?? '',
    }
  }
  if (cartons) {
    mappedInventoryItem.cartons = cartonsMapper(cartons, warehouseEvents);
  }

  return mappedInventoryItem;
};

const cartonsMapper = (cartons=null, warehouseEvents=null) => {
  const mappedCartons = cartons && cartons.length > 0 ? cartons.sort((first, second) => first.id.value > second.id.value).map((carton) => {
    // strip the 'value' off
    const newCarton = {
      ...carton,
      id: carton.id.value,
      itemId: carton.itemId.value,
      warehouseId: carton.warehouseId.value,
      warehouseEvents: [],
    };
    // add warehouseEvents to cartons
    if (warehouseEvents && warehouseEvents.hasOwnProperty(newCarton.id) 
        && Array.isArray(warehouseEvents[newCarton.id])) {
      // strip the 'value' off of properties
      newCarton.warehouseEvents = warehouseEvents[newCarton.id]
        .map((warehouseEvent) => {
          return {
            ...warehouseEvent,
            id: warehouseEvent.id.value,
            userId: warehouseEvent.userId.value,
            warehouseId: warehouseEvent.warehouseId.value,
            itemId: warehouseEvent.itemId.value,
            cartonId: warehouseEvent.cartonId.value,
          }
      });
    }
    return newCarton;
  }) : [];

  return mappedCartons;
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_CURRENT_INVENTORY_SUCCESS: {
      return {
        ...state,
        loader: false,
        inventoryData: action.payload
      };
    }
    case RESET_INVENTORY_ITEM: {
      return {
        ...state,
        loader: false,
        inventoryItem: INIT_STATE.inventoryItem,
      };
    }
    case FETCH_INVENTORY_ITEM_BY_CARTON_ID: {
      return {
        ...state,
        loader: true,
      };
    }
    case FETCH_INVENTORY_ITEM_CARTONS_SUCCESS: {
      const { cartons=null, warehouseEvents=null } = action.payload;
      return {
        ...state,
        loader: false,
        inventoryItem: {
          ...state.inventoryItem,
          cartons: cartonsMapper(cartons, warehouseEvents),
        },
      };
    }
    case FETCH_INVENTORY_ITEM_SUCCESS: {
      return {
        ...state,
        loader: false,
        inventoryItem: inventoryItemMapper(action.payload),
      };
    }
    case FETCH_INVENTORY_ITEM_ERROR: {
      return {
        ...state,
        loader: false,
        inventoryItem: INIT_STATE.inventoryItem,
      };
    }
    case ON_SHOW_LOADER: {
      return {
          ...state,
          loader: true
      }
    }
    case ON_HIDE_LOADER: {
        return {
            ...state,
            loader: false
        }
    }
    case CREATE_PRODUCT_SUCCESS: {
      return {
        ...state,
        createdProduct: action.payload,
      };
    }
    case CREATE_PRODUCT_ERROR: {
      return {
        ...state,
        createdProduct: INIT_STATE.createdProduct,
      };
    }
    case CREATE_PRODUCT_CLEAR: {
      return {
        ...state,
        createdProduct: INIT_STATE.createdProduct,
      };
    }
    default:
        return state;
    }
};
